<template>
    <div class="sub_contents">
        <div class="cont_center">
            
            <div class="error_box">
                <h1 class="title_error">Error</h1>

                <p class="text_error">일시적인 시스템 문제로 오류가 발생하였습니다. <br>잠시 후에 다시 시도해 주세요.</p>
            </div>

            <div class="btn_go_home">
                <RouterLink to="/" class="btn_type2">홈으로 가기</RouterLink>
            </div>
            
        </div>
    </div>
</template>